import React from "react";
import { Link } from "react-router-dom";
import { t } from "@/i18n";

export default function MarketingHeader() {
  return (
    <header className="fixed top-0 inset-x-0 z-50 glass">
      <span aria-hidden className="absolute bottom-0 left-12 right-12 h-px brass-line opacity-60" />
      <div className="max-w-6xl mx-auto px-6 lg:px-12 h-[72px] flex items-center justify-between">
        <Link to="/" className="block group" data-testid="marketing-logo">
          <span className="font-heading font-extralight text-[1.25rem] sm:text-[1.4rem] tracking-[0.55em] text-[var(--text-primary)] group-hover:text-[var(--gold)] transition-colors duration-700 ease-[cubic-bezier(0.22,1,0.36,1)]">
            SONARA
          </span>
        </Link>
        <nav className="hidden md:flex items-center gap-10 text-[10.5px] uppercase tracking-[0.22em] text-[var(--text-muted)]">
          <a href="#philosophy" className="hover:text-[var(--text-primary)] transition-colors duration-700" data-testid="nav-philosophy">{t("marketing.nav.philosophy")}</a>
          <a href="#product"    className="hover:text-[var(--text-primary)] transition-colors duration-700" data-testid="nav-product">{t("marketing.nav.product")}</a>
          <a href="#trial"      className="hover:text-[var(--text-primary)] transition-colors duration-700" data-testid="nav-trial">{t("marketing.nav.trial")}</a>
        </nav>
        <div className="flex items-center gap-3">
          <Link
            to="/login"
            className="text-[10.5px] uppercase tracking-[0.22em] text-[var(--text-muted)] hover:text-[var(--gold)] transition-colors duration-700"
            data-testid="nav-login"
          >
            {t("marketing.nav.login")}
          </Link>
        </div>
      </div>
    </header>
  );
}
